import script from "./ImageCropper.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCropper.vue?vue&type=script&setup=true&lang=js"

import "./ImageCropper.vue?vue&type=style&index=0&id=8753cec0&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8753cec0"]])

export default __exports__